import React from 'react'
import FeesProgress from './FeesProgress';


const Page = () => {
    return (
        <div className="d-flex justify-content-center align-items-center mb-5">
          <div className="w-100">
            <FeesProgress/>
          </div>
        </div>
      );
}

export default Page